import _setPrototypeOf from './setPrototypeOf.js';

function _inheritsLoose(t, o) {
  t.prototype = Object.create(o.prototype), t.prototype.constructor = t, _setPrototypeOf(t, o);
}

export { _inheritsLoose as default };
